/**
 * Einstieg Sprachschalter (sitewide bei EN live; eingebunden über mp-lang-switch.php).
 */
import { initLanguageSwitch } from '../components/language-switch/language-switch.js';

initLanguageSwitch();
